import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../Loaders/Spinner';
import CommonTable from './CommonTable';
import { LoadingData } from './LoadingState';

import './Table.scss';

interface CommonTablePaginateProps {
  tableHeader: Object;
  tableData: Object[];
  pageLength: number;
  isLoading: boolean;
  loadingData: LoadingData;
  loader: React.ReactElement;
  id: string;
  onRowClick: Function;
  emptyStateComponent: React.ReactElement | null;
  emptyStateMessage: string;
}


function CommonTablePaginate({
  tableHeader,
  tableData,
  pageLength,
  isLoading,
  loadingData,
  loader,
  id,
  onRowClick,
  emptyStateComponent,
  emptyStateMessage,
}: CommonTablePaginateProps) {
  const totalRows = tableData.length;
  const [paginatedData, setPaginatedData] = useState<Object[]>([]);
  const [paginatedIndex, setPaginatedIndex] = useState(0);

  const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setPaginatedIndex((newPage - 1) * pageLength);
  };

  useEffect(() => {
    setPaginatedIndex(0);
    setPaginatedData(tableData.slice(0, 0 + pageLength));
  }, [tableData]);

  useEffect(() => {
    setPaginatedData(tableData.slice(paginatedIndex, paginatedIndex + pageLength));
  }, [paginatedIndex]);

  return (
    <CommonTable
      tableHeader={tableHeader}
      tableData={paginatedData}
      isLoading={isLoading}
      loadingData={loadingData}
      loader={loader}
      id={id}
      onRowClick={onRowClick}
      pageNumber={paginatedIndex / pageLength}
      pageLength={pageLength}
      totalRows={totalRows}
      handlePageChange={handlePageChange}
      emptyStateComponent={emptyStateComponent}
      emptyStateMessage={emptyStateMessage}
    />
  );
}

CommonTablePaginate.defaultProps = {
  pageLength: 10,
  isLoading: true,
  loadingData: {
    rowSize: 6,
    colSize: 4,
  },
  loader: <Spinner />,
  id: '',
  onRowClick: () => {},
  emptyStateComponent: null,
  emptyStateMessage: 'No recorded usage found',
};

CommonTablePaginate.propTypes = {
  tableHeader: PropTypes.object.isRequired,
  tableData: PropTypes.array.isRequired,
  pageLength: PropTypes.number,
  isLoading: PropTypes.bool,
  loadingData: PropTypes.object,
  loader: PropTypes.element,
  id: PropTypes.string,
  onRowClick: PropTypes.func,
  emptyStateComponent: PropTypes.element,
  emptyStateMessage: PropTypes.string,
};

export default CommonTablePaginate;
